<script lang="ts" setup>
const isHovered = defineModel<boolean>('isHovered', { required: true });
</script>

<template>
  <!-- keep your pb-6; give the card a solid bg so nothing “peeks through” -->
  <div class="relative overflow-hidden pb-6 rounded-lg bg-neutral-950">
    <!-- ...card content... -->

    <!-- stacked layers; bottom one never moves -->
    <div class="pointer-events-none absolute inset-x-0 bottom-0 flex flex-col items-center">
      <!-- TOP -->
      <div
        class="transform-gpu bg-neutral-400 w-[95%] h-8 rounded-b-lg border border-neutral-900 z-[3]"
        :class="['transition-transform duration-150', isHovered && '-translate-y-[2px]']" />
      <!-- MIDDLE -->
      <div
        class="transform-gpu bg-neutral-600 w-[90%] h-8 -mt-6 rounded-b-lg border border-neutral-900 z-[2]"
        :class="['transition-transform duration-150', isHovered && '-translate-y-[1px]']" />
      <!-- BOTTOM (anchored, no translate) -->
      <div
        class="transform-gpu bg-neutral-500 w-[84%] h-8 -mt-6 rounded-b-lg border border-neutral-900 z-[1]" />
    </div>
  </div>
</template>
